import React, { PureComponent } from 'react';
import moment from 'moment';
import 'moment/locale/ru';
import { Map, YMaps } from 'react-yandex-maps';

import './PlacemarkMap.css';

class PlacemarkMap extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      center: [55.753215, 37.622504],
      ymaps: false,
      map: false,
    };
  }

  componentDidMount() {
    this.setMarkers();
  }

  setMarkers() {
    if (this.state.map && this.props.markers && this.props.markers.length > 0) {
      this.addOrdersToMap(this.props.markers, this.state.map);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.markers !== prevProps.markers ||
      this.state.map !== prevState.map
    ) {
      this.setMarkers();
    }
  }

  addOrdersToMap = (markers, map) => {
    map.geoObjects.removeAll();

    const customBalloonContentLayout = this.state.ymaps.templateLayoutFactory.createClass(
      [
        '<div class="balloons">',
        '{% for geoObject in properties.geoObjects %}',
        '<div class="balloons__item">',
        '<div class="balloons__article">{{ geoObject.properties.iconContent|raw }}</div>',
        '<div class="balloons__date">{{ geoObject.properties.iconDescription|raw }}</div>',
        '</div>',
        '{% endfor %}',
        '</div>',
      ].join('')
    );

    const clusterer = new this.state.ymaps.Clusterer({
      preset: 'islands#blueClusterIcons',
      synchAdd: true,
      clusterDisableClickZoom: true,
      clusterOpenBalloonOnClick: true,
      clusterBalloonPanelMaxMapArea: 0,
      clusterBalloonContentLayout: customBalloonContentLayout,
    });

    map.geoObjects.add(clusterer);

    const MyIconContentLayout = this.state.ymaps.templateLayoutFactory.createClass(
      '<div class="balloon">' +
        '<div class="balloon__article">$[properties.iconContent]</div>' +
        '<div class="balloon__date">$[properties.iconDescription]</div>' +
        '</div>'
    );

    const addMarkerToMap = (item, coords) => {
      const placemark = new this.state.ymaps.Placemark(
        coords,
        {
          iconContent: item.article
            ? item.article.replace(/\W/gi, '').replace(/(.{3})/g, '$1 ')
            : '—',
          iconDescription: item.dateApplication
            ? 'Дата подачи: ' +
              moment(parseInt(item.dateApplication)).format('DD.MM.YYYY')
            : null,
        },
        {
          iconContentOffset: [30, 100],
          iconContentLayout: MyIconContentLayout,
        }
      );
      clusterer.add(placemark);
    };

    markers.forEach(item => {
      if (item.latlng) {
        addMarkerToMap(item, item.latlng);
      } else if (item.address) {
        this.state.ymaps.geocode(item.address).then(res => {
          const firstGeoObject = res.geoObjects.get(0);
          const coords = firstGeoObject.geometry.getCoordinates();
          addMarkerToMap(item, coords);
        });
      }
    });
    map.setBounds(map.geoObjects.getBounds(), {
      checkZoomRange: true,
      zoomMargin: 35,
    });
  };

  initMap = ref => {
    if (!this.state.map) {
      this.setState((state, props) => ({
        map: ref,
      }));
    }
  };

  initYmaps(ymaps) {
    this.setState(() => ({
      ymaps: ymaps,
    }));
  }

  render() {
    return (
      <YMaps
        query={{
          apikey: 'b6a66b8f-dc2c-4946-a916-0fb0ca680e5a',
        }}
        onApiAvaliable={ymaps => this.initYmaps(ymaps)}
      >
        <Map
          state={{
            center: this.state.center,
            zoom: 10,
            controls: [],
          }}
          instanceRef={ref => this.initMap(ref)}
          width={'100%'}
          height={505}
        />
      </YMaps>
    );
  }
}

export default PlacemarkMap;
